export const API_BASE_PATH = "https://frontend-qa.nogrunt.com";
export const API_BASE_RELATIVE_PATH = "/KeyLogging/ReactApp";
export const FORGE_IAM_ACCESS_TOKEN_KEY = "";
export const API_TIMEOUT = 60000;
export const mock_Data = "!mock";
export const FILE_BASE_PATH = "https://file-qa.nogrunt.com";
export const API_BACKEND_URL = "https://ai-qa.nogrunt.com/api";
export const TEST_CASE_GENERATION_URL = "https://gentc-qa.nogrunt.com";
export const APPIUM_INSPECTOR_URL = "https://appium-qa.nogrunt.com";
export const AGENTIC_AI_TESTING_URL = "https://ngeval-qa.nogrunt.com/";
export const CASHFREE_SDK_SRC = "https://sdk.cashfree.com/js/v3/cashfree.js";
export const isAssureQ = false;
